// src/components/DockedCallBar.jsx
import React, { useState, useMemo } from 'react';
import { useVoip } from '../voip/VoipProvider';
import '../assets/styles/docked-call-bar.less';

const DockedCallBar = () => {
  const {
    callPhase,
    incomingCall,
    activeCall,
    answer,
    reject,
    hangup,
    toggleMute,
    toggleHold,
    isMuted,
    isHeld,
  } = useVoip();

  const [isExpanded, setIsExpanded] = useState(true);
  const currentCall = incomingCall || activeCall;
  const hasCall = currentCall && callPhase !== 'idle' && callPhase !== 'ended';

  // Bar height control
  // let barHeight = 0;
  // if (hasCall) {
  //   barHeight = isExpanded ? 120 : 40;
  // }

  // Existing remoteIdentity fields (for incoming or established calls)
  const callerDisplay =
  currentCall?.remoteIdentity?.displayName ||
  currentCall?._remoteDisplayName ||
  currentCall?._outgoingTarget ||
  '';

  const callerUri = currentCall?.remoteIdentity?.uri?.toString() || '';
  const callerNumber = useMemo(() => {
    // Prefer our stored dialed number first
    if (currentCall?._outgoingTarget) {
      return currentCall._outgoingTarget;
    }
    return callerUri.replace(/^sip:([^@]+)@.*$/, '$1');
  }, [callerUri, currentCall?._outgoingTarget]);

  // Invisible spacer to push page content up
  return (
    <>
      <div
        className="docked-call-spacer"
        style={{ height: '1px', transition: 'height 0.25s ease' }}
      />
      {hasCall && (
        <div className={`docked-call-bar ${isExpanded ? 'is-expanded' : 'is-collapsed'}`}>
          <div className="call-bar-header" onClick={() => setIsExpanded(!isExpanded)}>
            <span className="caller-info">
              {callPhase === 'ringing' ? 'Incoming call from ' : 'In call with '}
              <strong>{callerDisplay || 'Unknown'}</strong>
              {callerDisplay && callerNumber && (
                <span className="caller-number"> ({callerNumber})</span>
              )}
            </span>
            <span className="toggle">{isExpanded ? '▼' : '▲'}</span>
          </div>
          {isExpanded && (
            <div className="controls">
              {callPhase === 'ringing' ? (
                <>
                  <button type="button" className="btn-accept" onClick={answer}>Answer</button>
                  <button type="button" className="btn-reject" onClick={reject}>Reject</button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className={`btn-secondary ${isMuted ? 'active' : ''}`}
                    onClick={toggleMute}
                  >
                    {isMuted ? 'Unmute' : 'Mute'}
                  </button>
                  <button
                    type="button"
                    className={`btn-secondary ${isHeld ? 'active' : ''}`}
                    onClick={toggleHold}
                  >
                    {isHeld ? 'Resume' : 'Hold'}
                  </button>
                  <button type="button" className="btn-reject" onClick={hangup}>
                    Hang Up
                  </button>
                </>
              )}
            </div>
          )}
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <audio id="remoteAudio" autoPlay playsInline />
        </div>
      )}
    </>
  );
};

export default DockedCallBar;
